import { CatCampaignRecord } from '@/types';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

interface Props {
  rowId: string;
  name: string;
  campaign?: CatCampaignRecord;
  handleOpen: (id: string, name: string, campaign?: CatCampaignRecord) => void;
  handleEdit: () => void;
  handleDelete: () => void;
  handleComplete: () => void;
  disableDelete: boolean;
}

const ActionsMenu = ({
  rowId,
  name,
  campaign,
  handleOpen,
  handleEdit,
  handleDelete,
  handleComplete,
  disableDelete,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        id={`${rowId}-open-action-menu-icon`}
        data-testid={`${rowId}-open-action-menu-icon`}
        onClick={(evt) => {
          handleOpen(rowId, name, campaign);
          setAnchorEl(evt.currentTarget);
        }}
        aria-label={`Open actions menu for ${name}`}
        aria-haspopup="true"
        aria-controls={`${rowId}-action-menu-icon`}
        size="large"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={`${rowId}-action-menu`}
        data-testid={`${rowId}-open-action-menu`}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorEl={anchorEl}
      >
        <MenuItem
          data-testid={`${rowId}-open-action-menu-edit`}
          onClick={() => {
            handleEdit();
            closeMenu();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          data-testid={`${rowId}-open-action-menu-complete`}
          onClick={() => {
            handleComplete();
            closeMenu();
          }}
        >
          Complete
        </MenuItem>
        <MenuItem
          disabled={disableDelete}
          data-testid={`${rowId}-open-action-menu-delete`}
          onClick={() => {
            handleDelete();
            closeMenu();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActionsMenu;
